import './comp_oil_changes.css'

const Comp_oil_changes=({ percentage = 0, label = 'Oil Changes - This Week' }) => {
  return (
    <div className="progress-card-oilchanges d-flex flex-column justify-content-center align-items-center">
      <div className="circle">
        <div className="percentage">
          {percentage}
        </div>
      </div>
      <div className="label">{label}</div>
    </div>
  );
};

export default Comp_oil_changes